<script>
    import logolg from './logo-lg.svg';
    import logolgeng from './logo-lg-eng.svg';
    import logoxs from './logo-xs.svg';
    import {isOnDanish} from "../../utils/is-on-language";

    let UNIQUE_ID = 0;

    /**
     * makes ids inside the svg unique by appending another unique number to the id
     */
    function replaceID (svgStr) {
        const id = UNIQUE_ID++;
        return svgStr.replace(/id="(\w+)"/g, function (_, prevId) {
            return `id="${prevId}${id}"`;
        }).replace(/xlink:href="#(\w+)"/g, function (_, prevId) {
            return `xlink:href="#${prevId}${id}"`;
        });
    }

    export default {
        props: {
            disableFocus: {
                type: Boolean,
                default: false,
            }
        },
        data () {
            return {
                logolg: replaceID(logolg),
                logolgeng: replaceID(logolgeng)
            };
        },
        render(h) {
            return h('a', {
                domProps: {
                    href: isOnDanish() ? '/' : '/english'
                },
                attrs: {
                    'aria-label': isOnDanish() ? 'Dansk hjemmeside' : 'English homepage',
                    'aria-hidden': this.disableFocus,
                    tabindex: this.disableFocus ? '-1' : '0',
                },
            }, [
                h('span', {
                    class: 'd-none d-md-inline-block kunst-logo js-kunst-logo',
                    domProps: {
                        innerHTML: isOnDanish() ? this.logolg : this.logolgeng
                    }
                }),
                h('span', {
                    class: 'd-inline-block d-md-none kunst-logo js-kunst-logo',
                    domProps: {
                        innerHTML: logoxs
                    }
                }),
            ]);
        }
    };
</script>
